import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';
import { Iconify, type IconifyName } from 'src/components/iconify';

// ----------------------------------------------------------------------

/** 将菜单 icon 标识转为导航图标节点 */
export function resolveNavIcon(icon?: string): React.ReactNode | undefined {
  if (!icon) {
    return undefined;
  }

  if (icon.startsWith('ic-')) {
    return <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${icon}.svg`} />;
  }

  return <Iconify icon={icon as IconifyName} />;
}
